import { addDays, todayStr } from "./format";

/**
 * Moves in Progress board columns.
 *
 * "Move in Progress Completed" lists every job whose move-in-progress call the
 * MC marked completed (the `inProgressCallDone` tag, set on the In Progress
 * tab) — whether or not the move had an escalation, and it stays listed once
 * the job moves on to Post Move. Dated by when the call was completed so the
 * column's All / Today / Past 7 days filter works on that.
 */
export const completedMoves = (state) =>
  (state.jobs || [])
    .filter((j) => j.inProgressCallDone)
    .map((j) => ({ ...j, landedAt: j.inProgressCallDoneAt || j.landedAt }));

/** "Moves in Progress": in-progress jobs whose call is still to be made. */
export const movesInProgress = (state) =>
  (state.jobs || []).filter((j) => j.status === "in-progress" && !j.inProgressCallDone);

/** Moves in Progress chips (Asana 1.2): the moves happening now, the ones about to start, or both. */
export const MOVES_IN_PROGRESS_FILTERS = [
  ["today", "Today"],
  ["next7", "Next 7 days"],
  ["all", "All"],
];

const UPCOMING_DAYS = 7;

/** The first service date booked (packing, loading, move…), else the move date. */
const firstServiceDate = (job) => {
  const dates = Object.values(job.serviceDates || {}).filter(Boolean).sort();
  return dates[0] || job.packingDate || job.moveDate || "";
};

const PRE_MOVE = ["daily-assign", "weekly-assign", "intro-done", "ready-to-confirm", "confirmed", "confirmed-update"];

/** Local jobs not yet started whose first service date falls within the next 7 days, soonest first. */
export const upcomingMoves = (state, today) =>
  (state.jobs || [])
    .filter((j) => j.moveType !== "ld" && PRE_MOVE.includes(j.status))
    .map((j) => ({ job: j, start: firstServiceDate(j) }))
    .filter(({ start }) => start && start > today && start <= addDays(today, UPCOMING_DAYS))
    .sort((a, b) => a.start.localeCompare(b.start))
    .map(({ job }) => job);

export const movesInProgressFiltered = (state, filterKey, today = todayStr()) => {
  if (filterKey === "next7") return upcomingMoves(state, today);
  if (filterKey === "all") return movesInProgress(state).concat(upcomingMoves(state, today));
  return movesInProgress(state);
};
